import { Box, Checkbox } from '@factorialco/deprecated-design-system'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import type BulkEditForm from 'modules/employees/pages/EditInBulk/forms/BulkEdit'

interface Props {
  bulkEditForm: BulkEditForm
  isChecked: boolean
  onChange: () => void
  onClick: () => void
  width: number
  formKey: 'manager_id' | 'timeoff_manager_id'
}

const ManagerCell = ({ bulkEditForm, isChecked, onChange, onClick, width, formKey }: Props) => {
  const formValue = bulkEditForm.get(formKey).value

  const selectedManagerId = formValue.toString() === '' ? undefined : parseInt(formValue, 0)

  const handleSelect = (selectedEmployeeId: number | undefined) => {
    if (!selectedEmployeeId) return

    bulkEditForm.setValues({
      [formKey]: selectedEmployeeId,
    })

    onChange()
  }

  const remainingWidth = width - 78

  return (
    <Box
      background="grey000White"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      height="full"
      paddingX="s16"
      paddingY="s12"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey000White',
        },
      }}
      gap="s16"
      style={{ width: `${width}px` }}
    >
      <Box flexNoShrink>
        <Checkbox checked={isChecked} onChange={onClick} />
      </Box>
      <Box style={{ width: `${remainingWidth}px` }}>
        <EmployeeSelectorV2
          onChange={handleSelect}
          value={selectedManagerId}
          options={{ hideSearchIcon: true }}
        />
      </Box>
    </Box>
  )
}

export default ManagerCell
